var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.375,
    cy: 11.625,
    r: 9.375,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0Z",
    fill: "#EF0303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1874 8.39354C19.0156 7.74761 18.5073 7.23804 17.8606 7.0634C16.6914 6.75 12 6.75 12 6.75C12 6.75 7.31101 6.75 6.13936 7.0634C5.49507 7.23565 4.9868 7.74522 4.8126 8.39354C4.5 9.56579 4.5 12.0132 4.5 12.0132C4.5 12.0132 4.5 14.4605 4.8126 15.6328C4.98441 16.2787 5.49268 16.7883 6.13936 16.9629C7.31101 17.2763 12 17.2763 12 17.2763C12 17.2763 16.6914 17.2763 17.8606 16.9629C18.5049 16.7907 19.0132 16.2811 19.1874 15.6328C19.5 14.4605 19.5 12.0132 19.5 12.0132C19.5 12.0132 19.5 9.56579 19.1874 8.39354Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5014 14.2691L14.3982 12.0132L10.5014 9.75718V14.2691Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.63a377a504beb82e32d1ec091cddb0ab.svg";
export { ForwardRef as ReactComponent };